import ApiClient from "../helpers/ApiClient";

const DRAFTS_KEY = "RESTROPROSAAS__DRAFTS";

export async function initPOS() {
    try {
      const response = await ApiClient.get("/pos/init");
      return response;
    } catch (error) {
      throw error;
    }
}

export async function createOrder(cart, deliveryType, customerType, customerId, tableId, selectedQrOrderItem, source = null) {
  try {
    const response = await ApiClient.post("/pos/create-order", {
      cart, deliveryType, customerType, customerId, tableId, selectedQrOrderItem, source
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function updateOrder(orderId, cart, deliveryType, customerType, customerId, tableId, source = null) {
  try {
    const response = await ApiClient.post(`/pos/update-order/${orderId}`, {
      cart, deliveryType, customerType, customerId, tableId, source
    });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function createOrderAndInvoice(cart, deliveryType, customerType, customerId, tableId, netTotal, taxTotal, serviceChargeTotal, total, selectedQrOrderItem, selectedPaymentType, discount, paidAmount, loyaltyRedemptionAmount = 0, loyaltyPointsRedeemed = 0, loyaltyItemsRedeemed = 0, multiPayments = [], source = null, roundOff = 0) {
  try {
    const response = await ApiClient.post("/pos/create-order-and-invoice", {
      cart, deliveryType, customerType, customerId, tableId,
      netTotal, taxTotal, serviceChargeTotal, total, selectedQrOrderItem, selectedPaymentType, discount, roundOff, paidAmount,
      loyaltyRedemptionAmount, loyaltyPointsRedeemed, loyaltyItemsRedeemed, multiPayments, source
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// drafts
/**
 * @returns {Array}
 *  */
export function getDrafts() {
  const draftsString = localStorage.getItem(DRAFTS_KEY);
  const drafts = draftsString ? JSON.parse(draftsString) : [];
  return drafts;
}

/**
 * @param {Array} drafts
 *  */
export function setDrafts(drafts) {
  localStorage.setItem(DRAFTS_KEY, JSON.stringify(drafts));
}
// drafts

// qr orders
export async function getQROrdersCount() {
  try {
    const response = await ApiClient.get("/pos/qrorders/count");
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getQROrders() {
  try {
    const response = await ApiClient.get("/pos/qrorders");
    return response;
  } catch (error) {
    throw error;
  }
}

export async function cancelAllQROrders() {
  try {
    const response = await ApiClient.post("/pos/qrorders/cancel-all");
    return response;
  } catch (error) {
    throw error;
  }
}

export async function cancelQROrder(orderId) {
  try {
    const response = await ApiClient.post(`/pos/qrorders/update-status/${orderId}`, {
      status: "cancelled"
    });
    return response;
  } catch (error) {
    throw error;
  }
}
// // qr orders

export async function getDeliveryRoomRequests() {
  try {
    const response = await ApiClient.get("/pos/delivery-room-requests");
    return response;
  } catch (error) {
    throw error;
  }
}

export async function acceptDeliveryRoomRequest(id, type) {
  try {
    const response = await ApiClient.post("/pos/requests/accept", { id, type });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function declineDeliveryRoomRequest(id, type) {
  try {
    const response = await ApiClient.post("/pos/requests/decline", { id, type });
    return response;
  } catch (error) {
    throw error;
  }
}

// src/controllers/pos.controller.js
// import ApiClient from "../helpers/ApiClient";

// const DRAFTS_KEY = "RESTROPROSAAS__DRAFTS";

// /* --------------------------------------------------------------
//    1. initPOS – returns full Axios response via .raw
//    -------------------------------------------------------------- */
// export async function initPOS() {
//   try {
//     const response = await ApiClient.raw.get("/pos/init");
//     return response;                     // ← full { status, data, ... }
//   } catch (error) {
//     throw error;
//   }
// }

// /* --------------------------------------------------------------
//    2. createOrder / createOrderAndInvoice – keep using .data
//    -------------------------------------------------------------- */
// export async function createOrder(
//   cart,
//   deliveryType,
//   customerType,
//   customerId,
//   tableId,
//   selectedQrOrderItem
// ) {
//   try {
//     const response = await ApiClient.post("/pos/create-order", {
//       cart,
//       deliveryType,
//       customerType,
//       customerId,
//       tableId,
//       selectedQrOrderItem,
//     });
//     return response;                     // ← .data (your code expects it)
//   } catch (error) {
//     throw error;
//   }
// }

// export async function createOrderAndInvoice(
//   cart,
//   deliveryType,
//   customerType,
//   customerId,
//   tableId,
//   netTotal,
//   taxTotal,
//   serviceChargeTotal,
//   total,
//   selectedQrOrderItem,
//   selectedPaymentType
// ) {
//   try {
//     const response = await ApiClient.post("/pos/create-order-and-invoice", {
//       cart,
//       deliveryType,
//       customerType,
//       customerId,
//       tableId,
//       netTotal,
//       taxTotal,
//       serviceChargeTotal,
//       total,
//       selectedQrOrderItem,
//       selectedPaymentType,
//     });
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }

// /* --------------------------------------------------------------
//    3. Drafts – unchanged
//    -------------------------------------------------------------- */
// export function getDrafts() {
//   const draftsString = localStorage.getItem(DRAFTS_KEY);
//   return draftsString ? JSON.parse(draftsString) : [];
// }

// export function setDrafts(drafts) {
//   localStorage.setItem(DRAFTS_KEY, JSON.stringify(drafts));
// }

// /* --------------------------------------------------------------
//    4. QR Orders – fix getQROrdersCount() to use .raw
//    -------------------------------------------------------------- */
// export async function getQROrdersCount() {
//   try {
//     const response = await ApiClient.raw.get("/pos/qrorders/count");
//     return response;                     // ← full response
//   } catch (error) {
//     throw error;
//   }
// }

// export async function getQROrders() {
//   try {
//     const response = await ApiClient.get("/pos/qrorders");
//     return response;                     // ← .data is fine here
//   } catch (error) {
//     throw error;
//   }
// }

// export async function cancelAllQROrders() {
//   try {
//     const response = await ApiClient.post("/pos/qrorders/cancel-all");
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }

// export async function cancelQROrder(orderId) {
//   try {
//     const response = await ApiClient.post(`/pos/qrorders/update-status/${orderId}`, {
//       status: "cancelled",
//     });
//     return response;
//   } catch (error) {
//     throw error;
//   }
// }

// /* --------------------------------------------------------------
//    5. EXPOSE .raw on every function (so POSPage can use it)
//    -------------------------------------------------------------- */
// initPOS.raw = ApiClient.raw;
// getQROrdersCount.raw = ApiClient.raw;
// createOrder.raw = ApiClient.raw;
// createOrderAndInvoice.raw = ApiClient.raw;
// getQROrders.raw = ApiClient.raw;
// cancelAllQROrders.raw = ApiClient.raw;
// cancelQROrder.raw = ApiClient.raw;